import { render, staticRenderFns } from "./pricing-card.vue?vue&type=template&id=66f9cede"
import script from "./pricing-card.vue?vue&type=script&lang=ts"
export * from "./pricing-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButton: require('/vercel/path0/components/ui/button.vue').default,ChefPricingList: require('/vercel/path0/components/chef/pricing-list.vue').default})
